import { h } from 'preact';
import PropTypes from 'prop-types';

import LatestNews from '../../containers/latest-news/latest-news';
import { latestNewsActions, latestNewsStore } from '../../../global-store/subjects/latest-news/latest-news';
import { useSubscribe } from '../../hooks/use-subscribe';

export const LatestNewsComponent = ({ $root, htmlProps, widget }) => {
  const state = useSubscribe(latestNewsStore);
  return <LatestNews htmlProps={htmlProps} widget={widget} $root={$root} state={state} actions={latestNewsActions} />;
};

LatestNewsComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
